import React from "react"

export const SuccessModalGrooveTicket = ({
  successModalClass,
  setButtonLoading,
  closeSuccessModal,
  segment,
  targetInbox,
}) => {
  const clickhandler = () => {
    setButtonLoading()
    closeSuccessModal()
    window.location.reload()
  }

  return (
    <div className={`modal ${successModalClass}`}>
      <div
        className="modal-background"
        onClick={clickhandler}
        role="button"
        tabIndex="0"
        onKeyDown={() => {}}
        aria-label="Close Success Modal"
      ></div>
      <div className="modal-content">
        <div className="box" style={{ maxWidth: 800, margin: "0 auto" }}>
          <p className="title is-4 mb-2">Vielen Dank für Ihre Anfrage!</p>
          <hr className="is-mitternachtsblau-30 my-3" />

          <p className="mb-5">Ihr Anliegen wird bearbeitet</p>

          <div className="mt-4">
            <button
              className="button is-sonnengelb ml-auto"
              aria-label="delete"
              onClick={clickhandler}
            >
              <b>Schließen</b>
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
